import { instanceConexao } from "services/axiosServices";
import { AxiosRequestConfig } from "axios";

/**
 * Função para listar cidades na revenda.
 *
 * @param {params} params - Parâmetros para listagem.
 * @param {string} params.authToken - Token de autenticação do usuário.
 * @param {string} params.idEmpreendimento - ID do empreendimento.
 * @returns {Promise<any>} - Resposta da API.
 */
export const postListarBairroRevenda = async (params: {
  authToken: string;
  idEmpreendimento: string;
}): Promise<any> => {
  const url = "/api/RevendaRegiao/ListarBairroPorFiltro";
  const { authToken, ...parameters } = params;
  const config: AxiosRequestConfig = {
    headers: {
      Authorization: `Bearer ${authToken}`,
    },
  };
  const response = await instanceConexao.post(url, parameters, config);
  return response?.data;
};
